import PropTypes from 'prop-types';
import React from 'react';
import { Grid, Icon, Input, Item } from 'semantic-ui-react';
import { withRouter } from 'found';
import withAuth from '../../App/Authenticate';
import MobileHeader from '../../App/MobileHeader';
import styles from '../../Event/List/EventList.scss';
import '../../../lib/stylesheets/ExpandCollapseTransition.css';
import Formsy from 'formsy-react';

const SearchPageComponent = class SearchPage extends React.Component {
  static propTypes = {
    toggleSidebar: PropTypes.func,
    location: PropTypes.object,
    viewer: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    children: PropTypes.object.isRequired,
    sidebarOpen: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.searchChange = this.searchChange.bind(this);
  }

  setQuery(key, value) {
    const { pathname, query } = this.props.location;
    query[key] = value;
    this.props.router.replace({ pathname, query });
  }

  searchChange(e) {
    this.setQuery('q', e.target.value);
  }

  render() {
    const {
      children,
      location,
      router,
      sidebarOpen,
      toggleSidebar,
      viewer
    } = this.props;
    const { query: { q } } = location;

    return (
      <div className={styles.scrollContainer}>
        <MobileHeader viewer={viewer} showSearch={false} router={router}>
          <div className='menu'>
            <Item as='a' onClick={() => router.go(-1)}>
              <Icon name='chevron left' />
            </Item>
            <Item
              as='a'
              className={`${sidebarOpen ? 'active ' : ''}`}
              onClick={toggleSidebar}
            >
              <Icon name='sidebar' />
            </Item>
          </div>
        </MobileHeader>
        <Grid container>
          <Grid.Row style={{ paddingBottom: '2em' }}>
            <Grid.Column>
              <h2>Search</h2>
              <Formsy.Form>
                <Input
                  fluid
                  value={q || ''}
                  name='q'
                  autoFocus
                  placeholder='Search by event name, contact, venue, or phone number...'
                  onChange={this.searchChange}
                  icon={{
                    name: q === '' ? 'search' : 'close',
                    onClick: () => this.searchChange({ target: { value: '' } }),
                    link: true
                  }}
                />
              </Formsy.Form>
            </Grid.Column>
          </Grid.Row>
          {children}
        </Grid>
      </div>
    );
  }
};

export default withRouter(withAuth(SearchPageComponent));



// WEBPACK FOOTER //
// ./webpack/components/App/Search/SearchPage.js